import { AddonTriggerContext } from '@dixa/lib-shared-habla';
import { ampli } from 'lib-shared-tracking';
import { ComponentProps, useContext } from 'react';
import { useLifecycles } from 'react-use';

import { ChangeSubjectFn } from 'components/editorQuickRepliesDropdown/editorQuickRepliesDropdown.types';

import type { QuickRepliesPreview } from '../quickRepliesContent/components/quickRepliesPreview/quickRepliesPreview';
import { QuickRepliesContent } from '../quickRepliesContent/quickRepliesContent';

type Props = {
  getRenderContext: ComponentProps<
    typeof QuickRepliesPreview
  >['getRenderContext'];
  changeSubject?: ChangeSubjectFn;
  onOpen?: () => void;
  onClose?: () => void;
};

export const QuickRepliesTrigger = ({
  getRenderContext,
  changeSubject,
  onOpen,
  onClose,
}: Props): JSX.Element => {
  const { matchText, insertContent, eventEmitter } =
    useContext(AddonTriggerContext);

  useLifecycles(
    () => {
      ampli.quickRepliesOpened({ openedBy: 'editorTrigger' });
      onOpen?.();
    },
    () => {
      onClose?.();
    },
  );

  return (
    <QuickRepliesContent
      editorSearchTrigger={matchText}
      insertContent={insertContent}
      getRenderContext={getRenderContext}
      changeSubject={changeSubject}
      eventEmitter={eventEmitter}
    />
  );
};
